import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Zap, DollarSign, BookOpen, Star } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const InternalLinks = ({ type = 'services' }) => {
  const { language } = useLanguage();

  const links = {
    services: {
      title: language === 'fr' ? 'Découvrez Nos Services' : 'Discover Our Services',
      description: language === 'fr' 
        ? 'Explorez tous les services Body-Up pour atteindre vos objectifs fitness'
        : 'Explore all Body-Up services to achieve your fitness goals',
      items: [
        {
          to: '/services',
          icon: Zap,
          label: language === 'fr' ? 'Tous nos services' : 'All our services',
          description: language === 'fr' ? 'EMS, Boxing, Scanner 3D, Power Plate...' : 'EMS, Boxing, 3D Scanner, Power Plate...'
        },
        {
          to: '/tarifs',
          icon: DollarSign,
          label: language === 'fr' ? 'Nos tarifs' : 'Our prices',
          description: language === 'fr' ? 'Dès CHF 55/séance - Packs avantageux' : 'From CHF 55/session - Advantageous packages'
        }
      ]
    },
    blog: {
      title: language === 'fr' ? 'Articles Connexes' : 'Related Articles',
      description: language === 'fr'
        ? 'Continuez votre lecture avec ces articles fitness'
        : 'Continue reading with these fitness articles',
      items: [
        {
          to: '/blog',
          icon: BookOpen,
          label: language === 'fr' ? 'Tous les articles' : 'All articles',
          description: language === 'fr' ? 'Conseils fitness, nutrition, entraînement' : 'Fitness, nutrition, training tips'
        }
      ]
    },
    cta: {
      title: language === 'fr' ? 'Prêt à Commencer ?' : 'Ready to Start?',
      description: language === 'fr'
        ? 'Rejoignez les +200 clients satisfaits de Body-Up Nyon'
        : 'Join the +200 satisfied clients of Body-Up Nyon',
      items: [
        {
          to: '/contact',
          icon: Star,
          label: language === 'fr' ? 'Consultation GRATUITE' : 'FREE Consultation',
          description: language === 'fr' ? 'Premier rendez-vous sans engagement' : 'First appointment with no obligation',
          highlighted: true
        }
      ]
    }
  };

  const currentLinks = links[type];

  return (
    <div className="mt-12 p-6 bg-gradient-to-br from-zinc-900 to-black border border-white/10 rounded-2xl">
      <div className="flex items-center gap-2 mb-2">
        <div className="w-1 h-6 bg-gradient-to-b from-primary to-pink-500 rounded-full" />
        <h3 className="text-xl font-bold text-white">{currentLinks.title}</h3>
      </div>
      <p className="text-zinc-400 text-sm mb-6">{currentLinks.description}</p>
      
      <div className="grid gap-3">
        {currentLinks.items.map((item, index) => (
          <Link
            key={index}
            to={item.to}
            className={`group flex items-center gap-4 p-4 rounded-xl transition-all duration-300 ${
              item.highlighted
                ? 'bg-gradient-to-r from-primary to-pink-500 hover:from-primary/90 hover:to-pink-500/90'
                : 'bg-white/5 hover:bg-white/10 border border-white/10 hover:border-primary/50'
            }`}
          >
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
              item.highlighted
                ? 'bg-white/20'
                : 'bg-gradient-to-br from-primary to-pink-500'
            }`}>
              <item.icon className="w-5 h-5 text-white" />
            </div>
            <div className="flex-1 min-w-0">
              <p className={`font-semibold mb-0.5 ${
                item.highlighted ? 'text-white' : 'text-white'
              }`}>
                {item.label}
              </p>
              <p className={`text-sm ${
                item.highlighted ? 'text-white/80' : 'text-zinc-400'
              }`}>
                {item.description}
              </p>
            </div>
            <ArrowRight className={`w-5 h-5 flex-shrink-0 transition-transform group-hover:translate-x-1 ${
              item.highlighted ? 'text-white' : 'text-primary'
            }`} />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default InternalLinks;
